const PHONE_TYPES = [
	{ value: 1, text: 'Cell', railsValue: 0 },
	{ value: 2, text: 'Landline', railsValue: 1 },
];

export default PHONE_TYPES;
